interface OcrBadgeIconProps {
  height: number;
  width: number;
}

export const OcrBadgeIcon = ({
  height = 16,
  width = 16,
}: OcrBadgeIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="var(--ocr-badge-background, #fff)"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 11C0 4.92495 4.9248 0 10.9998 0V0C17.0749 0 21.9997 4.92495 21.9997 11V11C21.9997 17.075 17.0749 22 10.9998 22V22C4.9248 22 0 17.075 0 11V11Z"
        fill="var(--ocr-badge-background, #fff)"
      />
      <path
        d="M14.4832 8.50767C14.4832 8.23484 14.2621 8.01367 13.9892 8.01367H8.19127C7.91844 8.01367 7.69727 8.23484 7.69727 8.50767V8.50767C7.69727 8.7805 7.91844 9.00167 8.19126 9.00167H13.9892C14.2621 9.00167 14.4832 8.7805 14.4832 8.50767V8.50767Z"
        fill="var(--ocr-badge-color, #736C64)"
      />
      <path
        d="M7.69727 10.9188C7.69727 10.6101 7.94752 10.3599 8.25622 10.3599H13.9243C14.233 10.3599 14.4832 10.6101 14.4832 10.9188V10.9321C14.4832 11.2408 14.233 11.491 13.9243 11.491H8.25622C7.94752 11.491 7.69727 11.2408 7.69727 10.9321V10.9188Z"
        fill="var(--ocr-badge-color, #736C64)"
      />
      <path
        d="M7.69727 13.395C7.69727 13.0863 7.94752 12.836 8.25622 12.836H12.7866C13.0953 12.836 13.3455 13.0863 13.3455 13.395V13.4082C13.3455 13.7169 13.0953 13.9672 12.7866 13.9672H8.25622C7.94752 13.9672 7.69727 13.7169 7.69727 13.4082V13.395Z"
        fill="var(--ocr-badge-color, #736C64)"
      />
      <path
        d="M6 8.49023V6.84464C6 6.38432 6.37316 6.01116 6.83348 6.01116H8.54295"
        stroke="var(--ocr-badge-color, #736C64)"
        strokeWidth="0.833482"
        strokeLinecap="round"
      />
      <path
        d="M6 13.5117V15.1573C6 15.6176 6.37316 15.9908 6.83348 15.9908H8.54295"
        stroke="var(--ocr-badge-color, #736C64)"
        strokeWidth="0.833482"
        strokeLinecap="round"
      />
      <path
        d="M13.4766 6H15.166C15.6264 6 15.9995 6.37316 15.9995 6.83348V8.49872"
        stroke="var(--ocr-badge-color, #736C64)"
        strokeWidth="0.833482"
        strokeLinecap="round"
      />
      <path
        d="M13.4766 16H15.166C15.6264 16 15.9995 15.6268 15.9995 15.1665V13.5013"
        stroke="var(--ocr-badge-color, #736C64)"
        strokeWidth="0.833482"
        strokeLinecap="round"
      />
    </svg>
  );
};
